import { render, staticRenderFns } from "./InlineMessageBox.vue?vue&type=template&id=a62e3754&scoped=true&"
import script from "./InlineMessageBox.vue?vue&type=script&lang=js&"
export * from "./InlineMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./InlineMessageBox.vue?vue&type=style&index=0&id=a62e3754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62e3754",
  null
  
)

export default component.exports